import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

type AllowedRole = 'company_admin' | 'company_user';

export const ProtectedRoute: React.FC<{ children: React.ReactNode; role?: AllowedRole | AllowedRole[] }> = ({ children, role }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (role) {
    const roles = Array.isArray(role) ? role : [role];
    if (!roles.includes(user.role as AllowedRole)) return <Navigate to="/403" replace />;
  } else if (user.role !== 'company_admin' && user.role !== 'company_user') {
    return <Navigate to="/403" replace />;
  }
  return <>{children}</>;
};
